import React, { useState } from 'react'
import { Link } from 'gatsby'
// import { GitHubIcon } from '../social-share/github-icon'
import { ThemeSwitch } from '../theme-switch'
import { rhythm } from '../../utils/typography'
import { GnbBtn } from '../gnb/btn'
import { Gnb } from '../gnb'

import './index.scss'

export const Top = ({ title, location, rootPath, selectCategory }) => {
  const [gnbState, setGnbState] = useState('close')
  const [motionState, setMotionState] = useState(false)
  const isRoot = location.pathname === rootPath

  return (
    <div className="top">
      <div
        className="top-inner"
        style={{
          marginLeft: `auto`,
          marginRight: `auto`,
          maxWidth: '1000px',
          padding: `0 ${rhythm(3 / 4)}`,
        }}
      >
        {!isRoot && (
          <Link to={`/`} className="link">
            {title}
          </Link>
        )}
        {<ThemeSwitch />}
        {/* <GitHubIcon /> */}
        {
          <GnbBtn
            setGnbState={setGnbState}
            gnbState={gnbState}
            setMotionState={setMotionState}
          />
        }
      </div>
      {gnbState === 'open' && (
        <Gnb
          selectCategory={selectCategory}
          motionState={motionState}
          gnbState={gnbState}
          setGnbState={setGnbState}
          setMotionState={setMotionState}
        />
      )}
    </div>
  )
}
